
export class CapitalAvailable {
  id: number;
  pbAdjExcess: number;
  availableForNewInvestments: number;
  userUpdate: boolean;
}
